import { addEmployeeStatus } from "../../../../../actions/Utilities/EmployeeStatus";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";

const useAddEmployeeStatus = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    (employeeTypeNewData) => addEmployeeStatus(employeeTypeNewData),
    {
      onSuccess: (res) => {
        if (res == "Duplicate") {
          toast.fire(
            "Saving Failed",
            "Employee Status already exists!",
            "error"
          );
        } else {
          queryClient.invalidateQueries(["GetEmployeeStatus"]);
          toast.fire(
            "Success",
            "Employee Status Added Successfully",
            "success"
          );
        }
      },
      onError: () => {
        toast.fire("Failed", "Failed to Add Employee Status", "error");
      },
    }
  );

  return mutate;
};
export default useAddEmployeeStatus;
